'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var ChildBridge = (function (_React$Component) {
  _inherits(ChildBridge, _React$Component);

  function ChildBridge() {
    var _this = this;

    _classCallCheck(this, ChildBridge);

    _React$Component.apply(this, arguments);

    this.createChild = function (element) {
      var inject = _this.props.inject;

      _this.currentChild = element;

      return _react.cloneElement(_react2['default'].Children.only(element), _extends({}, inject(element), _this.events));
    };
  }

  ChildBridge.prototype.componentWillMount = function componentWillMount() {
    this.events = {};
    this.processEvents(this.props.events);
  };

  ChildBridge.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.processEvents(nextProps.events);
  };

  ChildBridge.prototype.processEvents = function processEvents(events) {
    var _this2 = this;

    [].concat(events).forEach(function (event) {
      _this2.events[event] = _this2.events[event] || function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this2.handleEvent(event, args);
      };
    });
  };

  ChildBridge.prototype.handleEvent = function handleEvent(event, args) {
    var _props;

    var handler = this.currentChild.props[event];
    (_props = this.props).onEvent.apply(_props, [event, handler].concat(args));
  };

  ChildBridge.prototype.render = function render() {
    var child = this.props.children;

    if (typeof child === 'function') return child(this.createChild);

    return this.createChild(child);
  };

  _createClass(ChildBridge, null, [{
    key: 'propTypes',
    value: {
      events: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
      onEvent: _react.PropTypes.func.isRequired,
      inject: _react.PropTypes.func.isRequired
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      events: []
    },
    enumerable: true
  }]);

  return ChildBridge;
})(_react2['default'].Component);

exports['default'] = ChildBridge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/topeka/ChildBridge.js
// module id = 584
// module chunks = 0